import type { FC } from 'react'
import styled from 'styled-components'

/**
 * Fixed-footprint placeholder for a flag-gated Home card while feature flags
 * resolve on a cold load. Reuses `.lmc-home-card` (min-height: 310px) so it
 * occupies the same grid slot as the real card and the swap causes no reflow.
 */
export const CardSkeleton: FC = () => (
  <div className="lmc-home-card" aria-hidden data-testid="home-card-skeleton">
    <SkeletonWrapper>
      <SkeletonLine $width="55%" $height="20px" />
      <SkeletonLine $width="85%" />
      <SkeletonLine $width="70%" />
      <SkeletonLine $width="60%" />
    </SkeletonWrapper>
  </div>
)

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
`

const SkeletonLine = styled.div<{ $width: string; $height?: string }>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height ?? '14px'};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.neutral.color8};
`

export default CardSkeleton
